/** Figma 5131:11493–5131:11509 — mobile promo block */
import { homeContentInnerMaxWidth } from './homeStyles'

export const homePromoNavy = '#003366'
export const homePromoBadgeBlue = '#3B82F6'
export const homePromoBadgeWidthPx = 157
export const homePromoBadgeHeightPx = 24
export const homePromoHeightPx = 363
export const homePromoRadiusPx = 10
export const homePromoContentPadLeftPx = 48
export const homePromoContentPadTopPx = 50
export const homePromoCopyMaxWidthPx = 448
export const homePromoHeadingGapPx = 23
export const homePromoPhoneWidthPx = 216
export const homePromoPhoneHeightPx = 442
export const homePromoPhoneTopPx = 48
export const homePromoPhoneRightPx = 49
export const homePromoPhoneShadow = '3px 0px 11px 0px #008CD0'
export const homePromoFloatIconBg = '#0EA5E9'
export const homePromoSubtextColor = 'rgba(255, 255, 255, 0.7)'
export const homePromoRewardsLabelColor = 'rgba(255, 255, 255, 0.6)'

/** Figma store row — same outer height + 1px white stroke (5131:11503 / 5131:11504) */
export const homePromoStoreBadgeHeightPx = 50
export const homePromoStoreBadgeBorderPx = 1

export const homePromoRootSx = {
  position: 'relative',
  width: '100%',
  maxWidth: homeContentInnerMaxWidth,
  height: { xs: 'auto', md: homePromoHeightPx },
  minHeight: { xs: 280, md: homePromoHeightPx },
  bgcolor: homePromoNavy,
  backgroundColor: homePromoNavy,
  borderRadius: `${homePromoRadiusPx}px`,
  overflow: 'hidden',
  mb: 4,
  boxSizing: 'border-box',
} as const

export const homePromoBadgeSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: homePromoBadgeWidthPx,
  minWidth: homePromoBadgeWidthPx,
  height: homePromoBadgeHeightPx,
  px: '12px',
  py: '4px',
  borderRadius: '999px',
  bgcolor: homePromoBadgeBlue,
  boxSizing: 'border-box',
  position: { xs: 'static', md: 'absolute' },
  top: { md: homePromoContentPadTopPx },
  left: { md: homePromoContentPadLeftPx },
  mb: { xs: `${homePromoHeadingGapPx}px`, md: 0 },
  zIndex: 2,
} as const

export const homePromoBadgeTextSx = {
  fontFamily: '"Sora", "Inter", sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: '0.3px',
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
} as const

export const homePromoHeadingSx = {
  fontWeight: 700,
  fontSize: { xs: '24px', md: '32px' },
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: '#FFFFFF',
  maxWidth: homePromoCopyMaxWidthPx,
  position: { xs: 'static', md: 'absolute' },
  top: { md: 97 },
  left: { md: homePromoContentPadLeftPx },
  mb: { xs: `${homePromoHeadingGapPx}px`, md: 0 },
  zIndex: 2,
} as const

export const homePromoSubtextSx = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '22.75px',
  color: homePromoSubtextColor,
  maxWidth: homePromoCopyMaxWidthPx,
  position: { xs: 'static', md: 'absolute' },
  top: { md: 190 },
  left: { md: homePromoContentPadLeftPx },
  mb: { xs: 2, md: 0 },
  zIndex: 2,
} as const

export const homePromoStoreRowSx = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '19px',
  position: { xs: 'static', md: 'absolute' },
  top: { md: 244 },
  left: { md: homePromoContentPadLeftPx },
  zIndex: 2,
} as const

const homePromoStoreBadgeLinkBaseSx = {
  display: 'inline-block',
  lineHeight: 0,
  flexShrink: 0,
  height: homePromoStoreBadgeHeightPx,
  boxSizing: 'border-box',
  border: `${homePromoStoreBadgeBorderPx}px solid #FFFFFF`,
  overflow: 'hidden',
} as const

/** Figma 5131:11503 — 163×49, 10px radius */
export const homePromoGooglePlayLinkSx = {
  ...homePromoStoreBadgeLinkBaseSx,
  borderRadius: '10px',
} as const

/** Figma 5131:11504 — 168×50, 8px radius */
export const homePromoAppStoreLinkSx = {
  ...homePromoStoreBadgeLinkBaseSx,
  borderRadius: '8px',
} as const

const homePromoStoreBadgeImgSx = {
  display: 'block',
  height: '100%',
  width: 'auto',
  maxWidth: 'none',
} as const

export const homePromoGooglePlayImgSx = homePromoStoreBadgeImgSx

export const homePromoAppStoreImgSx = homePromoStoreBadgeImgSx

export const homePromoPhoneWrapSx = {
  position: 'absolute',
  top: homePromoPhoneTopPx,
  right: homePromoPhoneRightPx,
  width: homePromoPhoneWidthPx,
  height: homePromoPhoneHeightPx,
  zIndex: 1,
  pointerEvents: 'none',
  display: { xs: 'none', md: 'block' },
} as const

export const homePromoPhoneImgSx = {
  width: '100%',
  height: '100%',
  objectFit: 'contain' as const,
  objectPosition: 'top center',
  filter: `drop-shadow(${homePromoPhoneShadow})`,
} as const

/** Figma 5131:11509 — x:455 y:89 within 884×363 card */
export const homePromoFloatSx = {
  position: 'absolute',
  top: 89,
  left: 455,
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  gap: '12px',
  p: '13px',
  borderRadius: '16px',
  bgcolor: 'rgba(255, 255, 255, 0.1)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  boxShadow:
    '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 8px 10px -6px rgba(0, 0, 0, 0.1)',
  zIndex: 3,
} as const

export const homePromoFloatIconSx = {
  width: 40,
  height: 40,
  borderRadius: '12px',
  bgcolor: homePromoFloatIconBg,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
} as const

export const homePromoFloatIconImgSx = {
  width: 22,
  height: 16,
  objectFit: 'contain' as const,
} as const

export const homePromoRewardsLabelSx = {
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: '15px',
  color: homePromoRewardsLabelColor,
  textTransform: 'uppercase',
} as const

export const homePromoRewardsAmountSx = {
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  color: '#FFFFFF',
} as const
